import api from "./config/axiosWith401Redirect";
import Design from "../models/Design";

const DESIGNS_URL = "/designs";

export const getDesign = async (designId: number): Promise<Design> => {
  const response = await api.get(`${DESIGNS_URL}/${designId}/`);
  return new Design(response.data);
};

export const createDesign = async (itemId: number): Promise<Design> => {
  const response = await api.post(`${DESIGNS_URL}/`, { item: itemId });
  return new Design(response.data);
};

export const updateDesign = async (
  designId: number,
  updatedData: Partial<Design>
): Promise<Design> => {
  const response = await api.patch(`${DESIGNS_URL}/${designId}/`, updatedData);
  return new Design(response.data);
};

export const getUserDesigns = async (): Promise<Design[]> => {
  const response = await api.get(`${DESIGNS_URL}/user/`);
  return response.data.map(
    (designData: Partial<Design>) => new Design(designData)
  );
};

export const deleteDesign = async (designId: number): Promise<void> => {
  await api.delete(`${DESIGNS_URL}/${designId}/`);
};

export const createCopiedDesign = async (
  copiedDesignId: number
): Promise<Design> => {
  const response = await api.post(`${DESIGNS_URL}/`, {
    copied_design: copiedDesignId,
  });
  return new Design(response.data);
};

export const createDesignPricingRequest = async (
  designId: number
): Promise<void> => {
  await api.post(`${DESIGNS_URL}/${designId}/request_pricing/`);
};
